import React from "react";
import { Activity, History, Zap } from "lucide-react";

export const AppHeader = ({ view, onNavigate }) => {
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#0B0F12]/85 border-b border-slate-800/80 px-4 sm:px-6 py-4 flex items-center justify-between"
    >
      <button
        data-testid="brand-logo"
        onClick={() => onNavigate("home")}
        className="flex items-center gap-3 group"
      >
        <div className="relative h-10 w-10 rounded-xl bg-emerald-500/15 border border-emerald-500/40 flex items-center justify-center pulse-ring">
          <Activity className="h-5 w-5 text-emerald-400" strokeWidth={2.5} />
        </div>
        <div className="text-left leading-none">
          <div className="font-heading font-extrabold text-lg tracking-tight text-slate-50">
            CREASE<span className="text-emerald-400">AI</span>
          </div>
          <div className="font-mono-tel text-[10px] tracking-[0.25em] text-slate-500 uppercase mt-0.5">
            Net Biomechanics
          </div>
        </div>
      </button>

      <div className="hidden lg:flex items-center gap-2.5 absolute left-1/2 -translate-x-1/2">
        <span className="font-mono-tel text-[10px] tracking-[0.2em] text-slate-500 uppercase">Powered by</span>
        <a
          data-testid="powered-by-rezzil"
          href="https://rezzil.com"
          target="_blank"
          rel="noopener noreferrer"
          className="opacity-80 hover:opacity-100 transition-opacity"
        >
          <img src="/rezzil-logo.png" alt="Rezzil" className="h-4 w-auto" />
        </a>
      </div>

      <nav className="flex items-center gap-2">
        <button
          data-testid="header-analyze-tab-btn"
          onClick={() => onNavigate("home")}
          className={`hidden sm:flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
            view !== "history"
              ? "bg-slate-800/70 text-slate-50"
              : "text-slate-400 hover:text-slate-200"
          }`}
        >
          <Zap className="h-4 w-4" /> Analyze
        </button>
        <button
          data-testid="header-history-tab-btn"
          onClick={() => onNavigate("history")}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-colors ${
            view === "history"
              ? "bg-slate-800/70 text-slate-50"
              : "text-slate-400 hover:text-slate-200"
          }`}
        >
          <History className="h-4 w-4" /> History
        </button>
        <div className="hidden md:flex items-center gap-2 ml-2 pl-3 border-l border-slate-800">
          <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
          <span className="font-mono-tel text-[10px] text-slate-500 tracking-wider uppercase">
            AI Vision
          </span>
        </div>
      </nav>
    </header>
  );
};
